import { keyframes, styled } from '@mui/system'
import { TTheme } from '@/core/theme'

const ping = keyframes`
    0% {
        transform: scale(1);
        opacity: 0.6;
    }
    100% {
        transform: scale(2.4);
        opacity: 0;
    }
`

export const BannerWrapper = styled('div')<{ theme?: TTheme }>`
    display: flex;
    align-items: flex-start;
    gap: 12px;
    margin-top: 16px;
    padding: 12px 16px;
    border: 1px solid
        ${({ theme }) => theme?.colors.semantic.caseLightRedBorder};
    border-left: 3px solid ${({ theme }) => theme?.colors.semantic.error};
    border-radius: 8px;
    background-color: ${({ theme }) => theme?.colors.semantic.caseLightRed};
`

export const PulsingDot = styled('span')<{ theme?: TTheme }>`
    position: relative;
    display: inline-block;
    flex-shrink: 0;
    width: 8px;
    height: 8px;
    margin-top: 6px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme?.colors.semantic.error};

    &::before {
        content: '';
        position: absolute;
        inset: 0;
        border-radius: 50%;
        background-color: ${({ theme }) => theme?.colors.semantic.error};
        animation: ${ping} 1.8s ease-in-out infinite;
    }

    @media (prefers-reduced-motion: reduce) {
        &::before {
            animation: none;
        }
    }
`

export const TextColumn = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 2px;
`
